import React, { useState, useEffect } from "react";
import './alertBox.style.scss';
import { runAlertSearch, runAlertDate } from "../../../utils/loadFunctions.ts";
import { usePlayer } from "../../../Contexts/playerData.context.jsx";
import { useNavBar } from "../../../Contexts/navbar.items.context.jsx";
import { useDataLayer } from "../../../Contexts/DataLayer.context.jsx";
import FBXCalendar from '../../Universals/FBXCalendar/fbxcalendar.component.jsx';
import DragBox2026 from "../../Universals/DragBox/DragBox2026/dragBox2026.component.jsx";

const AlertBox = () => {
    const [deadSearch, updateDeadSearch] = useState(false);
    const { setPlayerData, updateListLoadID, setPlayerID, setActivePlayer } = usePlayer();
    const { updateActiveSideButton } = useNavBar();
    const { updateWhichOneLiner } = useDataLayer();
    const [showInfo, updateShowInfo] = useState(false);
    const [activeAlertTab, setActiveAlertTab] = useState("Transactions");

    const alertTabs = [
        {
            key: "Transactions",
            label: "Transactions",
            title: "Transaction Alerts",
            body: "Players returned here had a Watchlist or Neg List transaction alert during the selected period.",
        },
        {
            key: "Notes",
            label: "Notes",
            title: "Note Alerts",
            body: "Players returned here had a visible note added while they were on your Watchlist.",
        },
        {
            key: "Reports",
            label: "Reports",
            title: "Report Alerts",
            body: "Players returned here had a visible report added or updated while they were on your Watchlist.",
        },
    ];

    const activeTabInfo = alertTabs.find((tab) => tab.key === activeAlertTab) || alertTabs[0];

    const DEFAULT_POS = { x: 57, y: 295 };
    const STORAGE_KEY_POS = "Alert_BOX_LOCATION";

    const clickButton = async (inval) => {
        localStorage.setItem('alertDates', JSON.stringify(alertDates));
        updateDeadSearch(false);
        try {
            const theData = await runAlertSearch(inval, activeAlertTab);
            if (theData.count !== null && theData.count > 0 && theData.count < 1000) {
                updateDeadSearch(false);
                updateWhichOneLiner(null);
                setPlayerData(theData.returnArray);
                updateActiveSideButton(null);
                const randomnum = Math.floor(Math.random() * 1_000_000) + 1;
                updateListLoadID(randomnum); // Update list load ID 
            } else {
                if (theData.count === 0) {
                    updateDeadSearch(true);
                }
            }
        } catch (error) {
            console.error("Error occurred while running alert search:", error);
        }
    };

    const handleCustomSearch = async () => {
        if (alertDates.start && alertDates.end) {
            localStorage.setItem('alertDates', JSON.stringify(alertDates));
            updateDeadSearch(false);
            try {
                const theData = await runAlertDate(alertDates.start, alertDates.end, activeAlertTab);
                if (theData.count !== null && theData.count > 0 && theData.count < 1000) {
                    updateDeadSearch(false);
                    updateWhichOneLiner(null);
                    setPlayerData(theData.returnArray);
                    updateActiveSideButton(null);
                    setPlayerID(theData.returnArray[0].FBXID);
                    setActivePlayer(theData.returnArray[0]);
                    const randomnum = Math.floor(Math.random() * 1_000_000) + 1;
                    updateListLoadID(randomnum); // Update list load ID 
                } else {
                    if (theData.count === 0) {
                        updateDeadSearch(true);
                    }
                }
            } catch (error) {
                console.error("Error occurred while running alert search:", error);
            }
        } else {
            alert('You Must set both Start and End Date for this search')
        }
    };

    const [openCalendar, setOpenCalendar] = useState(null);

    const handleToggleCalendar = (fieldName) => {
        if (openCalendar === fieldName) {
            setOpenCalendar(null);
            return; // do not continue... replaces else
        }
        setOpenCalendar(fieldName);
    };


    const [alertDates, updateAlertDates] = useState(
        {
            "start": null,
            "end": null,
        }
    )

    const handleDateChange = (field, value) => {
        updateAlertDates((prevDates) => ({
            ...prevDates,
            [field]: value,
        }));
    };

    useEffect(() => {
        const alertDatesData = localStorage.getItem('alertDates');
        if (alertDatesData) {
            // If data exists, parse and set it
            updateAlertDates(JSON.parse(alertDatesData));
        } else {
            // If no data exists, set to default values
            updateAlertDates({ start: null, end: null });
        }
    }, []);



    const resetSearchDates = () => {
        setOpenCalendar(null); // Close any open calendars
        updateAlertDates({ start: null, end: null }); // Reset all fields to null
        localStorage.removeItem('alertDates');
    };

    const openMore = () => {
        updateShowInfo(!showInfo);
    }

    const changeAlertTab = (tabKey) => {
        setActiveAlertTab(tabKey);
        updateDeadSearch(false);
        updateShowInfo(false);
    }

    return (
        <DragBox2026
            storageKey={STORAGE_KEY_POS}
            defaultPos={DEFAULT_POS}
            minWidth={900}
            maxWidth={900}
            showReset={true}
            title="Alert Notification Display"
        >

            <div className="alert-box-shell">
                <div className="alert-box-header">
                    <div>
                        <div className="alert-box-title">Alert Notifications</div>
                        <div className="alert-box-subtitle">{activeTabInfo.body}</div>
                    </div>
                    <button
                        type="button"
                        onClick={() => openMore()}
                        className={`btn btn-sm px-3 ${showInfo ? 'btn-warning' : 'btn-info'}`}
                    >
                        ?
                    </button>
                </div>

                <div className="alert-tabs" role="tablist" aria-label="Alert type">
                    {alertTabs.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={activeAlertTab === tab.key}
                            className={`alert-tab ${activeAlertTab === tab.key ? "active" : ""}`}
                            onClick={() => changeAlertTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {showInfo &&
                    <div className="alert-box-info">
                        <div className="fw-bold mb-1">{activeTabInfo.title}</div>
                        <p>{activeTabInfo.body}</p>
                        <p>Choose a period below and FBX will load the matching players into the main list so you can work them directly.</p>
                    </div>
                }

                {deadSearch &&
                    <div className="alert alert-warning text-center">No Records Were Returned for this Period</div>
                }
                <div className="fs-5 text-center fw-bold mb-2">Choose Period</div>
                <div className="d-flex gap-2 justify-content-between mb-4">
                    <div
                        className="btn btn-light col-15 alert-period-button"
                        onClick={() => clickButton('1')}
                    >
                        Yesterday
                    </div>
                    <div
                        className="btn btn-light col-15 alert-period-button"
                        onClick={() => clickButton('2')}
                    >
                        Last Week
                    </div>
                    <div
                        className="btn btn-light col-15 alert-period-button"
                        onClick={() => clickButton('3')}
                    >
                        Last 2 Weeks
                    </div>
                </div>
                {/* New Input Fields */}
                <div className="d-flex gap-3 justify-content-center align-items-center mb-3 px-5">
                    <FBXCalendar
                        fieldName="AlertStartDate"
                        placeholder="Start Date"
                        onDateChange={(value) => handleDateChange("start", value)}
                        isOpen={openCalendar === "AlertStartDate"}
                        dateIn={alertDates.start}
                        minYear="2015"
                        maxYear="2026"
                        style={{ width: "40%" }}
                        onToggleCalendar={handleToggleCalendar}
                    />
                    <FBXCalendar
                        fieldName="AlertEndDate"
                        placeholder="End Date"
                        onDateChange={(value) => handleDateChange("end", value)}
                        isOpen={openCalendar === "AlertEndDate"}
                        dateIn={alertDates.end}
                        minYear="2015"
                        maxYear="2026"
                        style={{ width: "40%" }}
                        onToggleCalendar={handleToggleCalendar}
                    />
                    <button className="btn btn-success text-white col-6 " onClick={handleCustomSearch}>
                        Search
                    </button>
                    <button className="btn btn-danger col-6" onClick={resetSearchDates}>
                        Reset
                    </button>
                </div>
            </div>
        </DragBox2026>
    );
};

export default AlertBox;
